<template>
  <b-sidebar
    id="sidebar-create-country"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ country.id ? $t('Update Country') : 'Create Country' }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <!-- Uz Name -->
        <b-form-group
          :label="$t('name uz')"
          label-for="uz-name"
        >
          <b-form-input
            id="uz-name"
            v-model="country.name.uz"
            trim
          />
        </b-form-group>

        <!-- Ru Name -->
        <b-form-group
          :label="$t('name ru')"
          label-for="ru-name"
        >
          <b-form-input
            id="ru-name"
            v-model="country.name.ru"
            trim
          />
        </b-form-group>

        <!-- En Name -->
        <b-form-group
          :label="$t('name en')"
          label-for="en-name"
        >
          <b-form-input
            id="en-name"
            v-model="country.name.en"
            trim
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ country.id ? $t('Update Country') : $t('Create Country') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
  },
  directives: {
    Ripple,
  },
  computed: {
    country: {
      get() {
        return this.$store.state[this.MODULE_NAME].country
      },
      set(data) {
        this.$store.commit(`${this.MODULE_NAME}/UPDATE_COUNTRY`, data)
      },
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit(`${this.MODULE_NAME}/FRESH_COUNTRY`)
      hide()
    },
    submit(hide) {
      this.$createSwal(this, this.country, `${this.MODULE_NAME}/${this.country.id ? 'update' : 'create'}`, () => {
        this.$emit('refetchData')
        this.$store.commit(`${this.MODULE_NAME}/FRESH_COUNTRY`)
      })
      hide()
    },
  },
  setup() {
    const MODULE_NAME = 'country'
    return {
      MODULE_NAME,
    }
  },
}
</script>
